<!-- SuitabilitySurvey.vue -->
<template>
  <div class="suitability-survey" v-if="isDataReady" :class="lang">
    <Progress progress="40"></Progress>
    <!-- 财务状况模块 -->
    <div class="survey-section">
      <div class="mainTitle">{{ $t('suitabilitySurvey.financialTitle') }}</div>
      <!-- 卡片 -->
      <div class="financial-cards">
        <div class="card" v-for="(item, index) in financial_list" :key="index" @click="showPicker(item)">
          <div class="left">
            <span class="label">{{ item.label }}</span>
            <span class="value">{{ getSelectedText(item) }}</span>
          </div>
          <div class="right">
            <van-icon name="arrow-down" :color="bgColor == 'black-theme' ? '#FFFFFF':'#333333'" />
          </div>
        </div>
      </div>
      <!-- 住宅模块 -->
<!--      <div class="residence">-->
<!--        <div class="subTitle">{{ $t('suitabilitySurvey.homeTitle') }}</div>-->
<!--        <div class="residence-options">-->
<!--          <div class="option-group" v-for="(item, index) in homeTenure.options" :key="index">-->
<!--            <van-radio-group class="mainRadio" v-model="homeTenure.value">-->
<!--              <van-radio  shape="square" :name="item.value" @click="clearChildrenValue(index)">-->
<!--                <template #icon="props">-->
<!--                  <img class="img-icon" :src="props.checked ? Checkd : CheckNone" />-->
<!--                </template>-->
<!--                {{item.text }}-->
<!--              </van-radio>-->
<!--            </van-radio-group>-->

<!--            <van-radio-group v-model="item.children.value" :disabled="homeTenure.value !== item.value">-->
<!--              <van-radio  v-for="(cItem, cIndex) in item.children.options" :key="`${index}-${cIndex}`"-->
<!--                class="subRadio" :name="cItem.value">-->
<!--                <template #icon="props">-->
<!--                  <img class="img-icon" :src="props.checked ? RadioCheck : RadioNone" />-->
<!--                </template>-->
<!--                {{ cItem.label }}-->
<!--              </van-radio>-->
<!--            </van-radio-group>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
      <!-- 资金来源模块 -->
      <div class="funding-source">
        <div class="subTitle">{{ $t('suitabilitySurvey.fundsTitle') }}</div>
        <van-checkbox-group class="checkbox-container"
          v-model="fundSource.value" @change="fundSourceChange">
          <div class="checkbox-item" v-for="item in fundSource.options" :key="item.value">
            <van-checkbox :name="item.value" shape="square">
              <template #icon="props">
                <img class="img-icon" :src="props.checked ? Checkd : CheckNone" />
              </template>
              {{ item.text }}
            </van-checkbox>
          </div>
          <!-- 其他输入框 -->
          <div class="other"
            :class="{focus: inputFocusId == 3, 'error': isClickNext && lastOption.inputValue == ''}"
            v-if="showOtherInput(fundSource.value, 6)">
            <span class="label" v-if="inputFocusId == 3 || lastOption.inputValue">{{ $t('suitabilitySurvey.otherSourcesOfFunds') }}</span>
            <Field
              class="val"
              v-model="lastOption.inputValue"
              :placeholder="inputFocusId == 3 ? '' : $t('suitabilitySurvey.otherSourcesOfFunds')"
              @focus="inputFocus(3)"
              @blur="inputBlur"
            ></Field>
          </div>
        </van-checkbox-group>
        <p class="errorText" v-if="showOtherInput(fundSource.value, 6) && isClickNext && lastOption.inputValue == ''">{{ $t('suitabilitySurvey.s000003') }}</p>
      </div>
    </div>
    <!-- 投资目标模块 -->
    <div class="survey-section">
      <div class="mainTitle">{{ $t('suitabilitySurvey.investmentTitle') }}</div>
      <div class="investmentGoal">
        <van-checkbox-group class="checkbox-container"
           v-model="invest_tagert_list.value"
          @change="investmentChange">
          <div class="checkbox-item" v-for="(item, index) in invest_tagert_list.options" :key="item.value">
            <van-checkbox :name="item.value" shape="square">
              <template #icon="props">
                <img class="img-icon" :src="props.checked ? Checkd : CheckNone" />
              </template>
              {{ item.label }}
            </van-checkbox>
            <!-- 其他输入框 -->
<!--            <div class="other outerSpacing"-->
<!--              :class="{ focus: inputFocusId == 2, 'error': isClickNext && item.inputValue == '' }"-->
<!--              v-if="index == invest_tagert_list.options.length - 1 && showOtherInput(invest_tagert_list.value, 5)">-->
<!--              <span class="label" v-if="inputFocusId == 2 || item.inputValue">{{ $t('suitabilitySurvey.otherFunds') }}</span>-->
<!--              <Field-->
<!--                class="val"-->
<!--                v-model="item.inputValue"-->
<!--                :placeholder="inputFocusId == 2 ? '' : $t('suitabilitySurvey.otherFunds')"-->
<!--                @focus="inputFocus(2)"-->
<!--                @blur="inputBlur"-->
<!--              ></Field>-->
<!--            </div>-->
<!--            <p class="errorText" v-if="index == invest_tagert_list.options.length - 1 && showOtherInput(invest_tagert_list.value, 5) && isClickNext && investlastOption.inputValue == ''">{{ $t('suitabilitySurvey.s000002') }}</p>-->
          </div>
        </van-checkbox-group>
      </div>
    </div>
    <!-- 投资经验模块 -->
    <div class="survey-section">
      <div class="mainTitle">{{ $t('suitabilitySurvey.investmentGoals') }}</div>
      <div class="investment-cards">
        <div v-for="(item, key) in investment_exp_list" :key="key" class="card" @click="showPicker(item)">
          <div class="left">
            <span class="label">{{ item.label }}</span>
            <span class="value">{{ getSelectedText(item) }}</span>
          </div>
          <div class="right">
            <van-icon name="arrow-down" :color="bgColor == 'black-theme' ? '#FFFFFF':'#333333'" />
          </div>
        </div>
        <!-- 衍生品买卖 -->
        <div class="card derivatives" @click="showPicker(derivative.t0)">
          <div class="left">
            <span class="label">{{ $t('suitabilitySurvey.derivatives') }}</span>
            <span class="value">{{ getSelectedText(derivative.t0) }}</span>
          </div>
          <div class="right">
            <van-icon name="arrow-down" :color="bgColor == 'black-theme' ? '#FFFFFF':'#333333'" />
          </div>
        </div>
        <!-- 了解衍生品买卖后展示 -->
        <div class="derivativeKnow" v-if="derivative.t0.value == 0">
          <div class="konwtitle">{{ $t('suitabilitySurvey.derivativesTips') }}</div>
          <div class="check-dom" v-for="(item, index) in derivative.t0.actions" :key="`${item.type}-${index}`">
            <!-- 多选 -->
            <template v-if="item.type == 'checkbox'">
              <div class="dom-title">{{ item.title }}</div>
              <van-checkbox-group
                v-model="derivative.t0.children[item.index]"
                direction="horizontal"
              >
                <van-checkbox class="itemChoices" v-for="(cItem, cIndex) in item.options" :key="cIndex" :name="cIndex" shape="square">
                  <template #icon="props">
                    <img class="img-icon" :src="props.checked ? Checkd : CheckNone" />
                  </template>
                  {{  cItem }}
                </van-checkbox>
              </van-checkbox-group>
            </template>
            <!-- 单选 -->
            <template v-if="item.type == 'radio'">
              <div class="dom-title">{{ item.title }}</div>
              <van-radio-group v-model="derivative.t0.children[item.index]" direction="horizontal" class="dom-chek">
                <van-radio v-for="(cItem, cIndex) in item.options" :key="cIndex" :name="cIndex" class="itemRadio">
                  <template #icon="props">
                    <img class="img-icon" :src="props.checked ? RadioCheck : RadioNone" />
                  </template>
                  {{ cItem }}
                </van-radio>
              </van-radio-group>
            </template>
            <!-- 单选 -->
            <template v-if="item.type == 'check'">
              <van-checkbox class="itemChoices" v-model="derivative.t0.children[item.index]" shape="square">
                <template #icon="props">
                  <img class="img-icon" :src="props.checked ? Checkd : CheckNone" />
                </template>
                {{ item.title }}
              </van-checkbox>
            </template>
          </div>
        </div>
        <!-- 不了解后展示 -->
        <div class="children-wrap" v-else>
          <div class="detail-wrap">
            <h3>{{ $t("suitabilitySurvey.derivative.t0.derivative_no_title") }}</h3>
            <p v-for="item in $t('suitabilitySurvey.derivative.t0.derivative_no')" :key="item" >
              ●{{ item }}
            </p>
          </div>
          <div class="no-agree">
            <van-checkbox v-model="isAgree" shape="square">
              <template #icon="props">
                <img class="img-icon" :src="props.checked ? Checkd : CheckNone" />
              </template>
              {{ $t("suitabilitySurvey.derivative.t0.derivative_no_agree") }}
            </van-checkbox>
          </div>
        </div>

      </div>
    </div>

    <!-- 底部按钮 -->
    <nav-buttons :disabled="canSubmitForm" navigationType="back" @on-next="submitForm"  :next-text="$route.query.change == 1 ? $t('openAccount.t000094') : $t('openAccount.t000095')" />
    <!-- 上拉选项弹窗 -->
    <van-popup v-model="showPickerPopup" position="bottom" class="picker-popup picker-ui">
      <p class="date-title">{{ currentItem ? currentItem.label : '' }}</p>
      <van-picker show-toolbar :columns="currentColumns"
        :default-index="currentDefaultIndex" @confirm="onPickerConfirm" @cancel="showPickerPopup = false" />
    </van-popup>
  </div>
</template>

<script>
import {
  Button,
  Checkbox,
  CheckboxGroup,
  Radio,
  RadioGroup,
  Picker,
  Popup,
  Icon,
  Toast,
  Field
} from "vant";
import navButtons from '../components/navButtons.vue'
import Progress from '../components/Progress.vue'
import RadioNone from '@/assets/images/open-account/radio.png'
import RadioCheck from '@/assets/images/open-account/radio_check.png'
import CheckNone from '@/assets/images/open-account/check_none.png'
import Checkd from '@/assets/images/open-account/check.png'

export default {
  name: "SuitabilitySurvey",
  components: {
    [Button.name]: Button,
    [Checkbox.name]: Checkbox,
    [CheckboxGroup.name]: CheckboxGroup,
    [Radio.name]: Radio,
    [RadioGroup.name]: RadioGroup,
    [Picker.name]: Picker,
    [Popup.name]: Popup,
    [Icon.name]: Icon,
    navButtons,
    Progress,
    Field
  },
  data() {
    this.process_id = 1;      // 开户类型
    return {
      RadioNone,
      RadioCheck,
      CheckNone,
      Checkd,
      financial_list: [],
      currentItem: null,
      homeTenure: {},
      fundSource: {},
      invest_tagert_list: {},
      investment_exp_list: {},
      showPickerPopup: false,
      isClickNext: false,
      derivative: {
        t0: {
          value: 0,
          children: {
            t0: true,
            t1: true,
            t2: true,
          }
        },
      },
      selectedDerivatives: [1, 2, 3],  // 衍生品买卖参数
      isDataReady: false,
      isAgree: true,
      lang: 'zh-CN',
      inputFocusId: -1
    };
  },
  computed: {
    canSubmitForm() {
      // 检查 住宅是否有勾选
      const hasEmptyHomeTenureChild = this.homeTenure.options.length > 0 &&
        this.homeTenure.options.some(item =>
          item.value == this.homeTenure.value && (item.children?.value == '' || item.children?.value == null)
        );

      // 检查 资金来源是否有勾选以及其他是否填写了
      let hasFundSourceEmpty = this.fundSource.value.length <= 0
      if(this.fundSource.value.includes(6) && !this.lastOption.inputValue){
        hasFundSourceEmpty = true
      }

      // 检查 投资目标是否有勾选以及其他是否填写了
      const hasInvestTargetEmpty = this.invest_tagert_list.value.length <= 0 ;

      // 检查投资经验是否都已选择
      const hasInvestmentExpEmpty = this.investment_exp_list.some(
        item => item.value === "" || item.value === null || item.value === undefined
      );

      // 检查衍生品相关条件
       const hasDerivativeIssue = this.derivative.t0.value == 0
        ? !this.derivative.t0.children.t0 && !this.derivative.t0.children.t1 && !this.derivative.t0.children.t2
        : !this.isAgree;

      // 当所有条件都为 false 时才能提交
      return hasEmptyHomeTenureChild ||
            hasFundSourceEmpty ||
            hasInvestTargetEmpty ||
            hasInvestmentExpEmpty ||
            hasDerivativeIssue;
    },
    currentColumns() {
      if (!this.currentItem) return [];
      // Vant Picker 用 v-html 渲染，`<HKD...` 会被当成标签吃掉
      return this.currentItem.options.map(option => ({
        text: String(option.text || "").replace(/</g, "&lt;"),
        value: option.value
      }));
    },
    currentDefaultIndex() {
      if (!this.currentItem) return 0;
      return this.currentItem.options.findIndex(option =>
        option.value === this.currentItem.value
      );
    },
    showOtherInput() {
      return (arr, num) => {
        return Array.isArray(arr) && arr.includes(num);
      }
    },
    bgColor() {
      return this.$store.getters["common/bgColor"];
    },
    lastOption() {
      return this.fundSource.options[this.fundSource.options.length - 1]
    },
    investlastOption() {
      return this.invest_tagert_list.options[this.invest_tagert_list.options.length - 1]
    },
  },
  methods: {
    init() {
      this.getLang();
      this.getFinancialData();
      this.getInvestmentGoalData();
      this.getExpData();
      this.getDerivData();
      this.fetchAccountData();
    },
    // 获取本地财务状况数据
    getFinancialData() {
      this.financial_list = this.$t('suitabilitySurvey.financial_list');
      this.fundSource = this.$t('suitabilitySurvey.fundSource');
      this.homeTenure = this.$t('suitabilitySurvey.homeTenure');
    },
    // 获取本地投资目标数据
    getInvestmentGoalData() {
      this.invest_tagert_list = this.$t('suitabilitySurvey.invest_tagert_list');
    },
    // 获取本地投资经验数据
    getExpData() {
      this.investment_exp_list = this.$t('suitabilitySurvey.investment_exp_list');
    },
    // 获取本地衍生品买卖数据
    getDerivData() {
      this.derivative = this.$t('suitabilitySurvey.derivative');
    },
    getLang() {
      this.lang = localStorage.getItem('localLang') || 'zh-CN';
    },
    // 显示上拉弹窗
    showPicker(item) {
      this.currentItem = item;
      this.showPickerPopup = true;
    },
    // 弹窗完成事件
    onPickerConfirm(selectedOption, index) {
      if (!this.currentItem) return;
      // 投资经验：值为下拉选中坐标 + 1
      if (this.investment_exp_list.includes(this.currentItem)) {
        const selectedIndex = typeof index === "number"
          ? index
          : this.currentItem.options.findIndex(opt => opt.text === (selectedOption?.text || selectedOption));
        this.currentItem.value = selectedIndex + 1;
      } else {
        this.currentItem.value = selectedOption.value;
      }
      this.showPickerPopup = false;
    },
    getSelectedText(item) {
      if (item.value === null || item.value === undefined) return "请选择";
      const option = item.options.find(opt => opt.value === item.value);
      return option ? option.text : "请选择";
    },
    // 提交
    async submitForm() {
      this.isClickNext = true;
      if ( this.canSubmitForm ) return false;
      const loading = Toast.loading({
        duration: 0,
        forbidClick: true,
        loadingType: "spinner",
        message: this.$t("common.loading_text")
      });
      await this.reportData();
      let path = "/open-account/riskQuestionnaire";
      if(this.$route.query.change == 1){
        path = "/open-account/home";
      }
      this.$router
          .push(path)
          .finally(() => {
            loading.clear();
          });
    },
    // 整理参数
    handleParameters() {
      return {
        financialSituation: this.financial_list.concat(this.fundSource).concat(this.homeTenure),
        investmentExp: this.investment_exp_list,
        investTarget: [this.invest_tagert_list],
        derivative: this.derivative
      }
    },
    clearChildrenValue(index) {
      // 清空选项的值
      this.homeTenure.options.forEach((item, i) => {
        if ( item.value != this.homeTenure.value ) {
          item.children.value = ''
        }
      });
    },
    // 获取数据
    async fetchAccountData() {
      try {
        const res = await this.$apis.accountSituationV2({ step_code: '1,7' });
        this.handleProcessId(res);      // 获取第一步的process_id
        this.handleConfigData(res);     // 获取当前页面的数据
        this.isDataReady = true;
      } catch (error) {
        
      }
    },
    handleProcessId(res) {
      if (res?.process_info?.[1]) {
        this.process_id = res?.process_info?.[1].process_id || res?.get_open_account_info?.open_status;
      }
    },
    // 处理适当性调查中的数据
    handleConfigData(res) {
      const {
        financialSituation = [],
        investTarget = [],
        investmentExp = [],
        derivative = {}
      } = res?.process_info?.[7]?.config_data  ? JSON.parse(res.process_info[7].config_data)?.examine_list : {};
      this.handleFinancialSituation(financialSituation);      // 处理财务状况数据
      this.handleInvestmentTarget(investTarget);              // 处理投资目标数据
      this.handleInvestmentExperience(investmentExp);         // 处理投资经验数据
      this.handleDerivative(derivative);                      // 处理衍生品买卖数据

    },
    handleFinancialSituation(financialSituation) {
      if (!Array.isArray(financialSituation) || !financialSituation.length) {
        return;
      }
      // 更新账户状况数据
      this.financial_list.forEach((item, index) => {
        if (financialSituation[index]) {
          item.value = financialSituation[index].value;
        }
      });
      // 更新资金来源数据
      const fundSourceData = this.findData(financialSituation, 'inputCheckbox');
      this.fundSource.value = fundSourceData?.[0]?.value || [1];
      // 确保 fundSourceData 和 options 存在且不为空（更新其它输入框数据）
      if (fundSourceData && fundSourceData[0] && fundSourceData[0].options.length > 0) {
        // 获取源数组最后一个元素的 inputValue
        const sourceInputValue = fundSourceData[0].options[fundSourceData[0].options.length - 1].inputValue;

        // 确保目标数组存在且有元素
        if (this.fundSource.options && this.fundSource.options.length > 0) {
          // 直接修改目标数组最后一个元素的 inputValue
          this.fundSource.options[this.fundSource.options.length - 1].inputValue = sourceInputValue;
        }
      }
      // 更改住宅数据
      const homeTenure = this.findData(financialSituation, 'multiSelect')[0];
      if (homeTenure?.options) {
        this.homeTenure.value = homeTenure.value;
        this.homeTenure.options.forEach((item, index) => {
            if (homeTenure.options[index]) {
              item.children.value = homeTenure.options[index].children.value;
            }
        });
      }
    },
    handleInvestmentTarget(investTarget) {
      if ( Array.isArray(investTarget) && investTarget.length > 0 ) {
        this.invest_tagert_list.value = investTarget[0]?.value || [1];
        // 确保 investTarget 和 options 存在且不为空（更新其它输入框数据）
        if (investTarget && investTarget[0] && investTarget[0].options.length > 0) {
          // 获取源数组最后一个元素的 inputValue
          const sourceInputValue = investTarget[0].options[investTarget[0].options.length - 1].inputValue;
          // 确保目标数组存在且有元素
          if (this.invest_tagert_list.options && this.invest_tagert_list.options.length > 0) {
            // 直接修改目标数组最后一个元素的 inputValue
            this.invest_tagert_list.options[this.invest_tagert_list.options.length - 1].inputValue = sourceInputValue;
          }
        }
      }
    },
    handleInvestmentExperience(investmentExp) {
      if ( Array.isArray(investmentExp) && investmentExp.length > 0 ) {
        this.investment_exp_list.forEach( (item, index) => {
          if (investmentExp[index]) {
            item.value = investmentExp[index].value;
          }
        })
      }
    },
    handleDerivative(derivative) {
      if (!derivative || !derivative.t0) {
        return;
      }
      // value 可能为 0（是），不能用 if(value) 判断
      if (derivative.t0.value !== undefined && derivative.t0.value !== null && derivative.t0.value !== "") {
        this.derivative.t0.value = derivative.t0.value;
      }
      const children = derivative.t0.children || derivative.children;
      if (children) {
        this.derivative.t0.children = children;
      }
    },
    findData(list, type) {
      return list.filter(item => item.type == type);
    },
    fundSourceChange(arr) {
      if ( !arr.includes(6) ) {
        this.fundSource.options[this.fundSource.options.length - 1].inputValue = '';
      }
    },
    investmentChange(arr) {
      if ( !arr.includes(5) ) {
        this.invest_tagert_list.options[this.invest_tagert_list.options.length - 1].inputValue = '';
      }
    },
    async reportData() {
      const config_data = {
        examine_list:{
          ...this.handleParameters()
        }
      }
      await this.$apis.supplementSaveApi({ process_id: this.process_id, step_code: 7, step_order: 7, config_data: config_data });
    },
    inputFocus(id){
      this.inputFocusId = id;
    },
    inputBlur(){
      this.inputFocusId = null;
    },
  },
  created() {
    this.init();
  },
  beforeDestroy() {
    // this.reportData();
  }
};
</script>

<style lang="less" scoped>
.suitability-survey {
  background-color: white;
  padding: 62px 0px 200px;

  .survey-section {
    background-color: #fff;
    border-radius: 16px;

    .mainTitle {
      color: #17161C;
      font-size: 36px;
      line-height: 36px;
      font-weight: 500;
      line-height: 88px;
      padding: 14px 32px 0;
      border-bottom: 1px solid #f3f3f3;
    }

    .checkbox-container {
      display: flex;
      flex-wrap: wrap;

      .checkbox-item {
        width: calc(50% - 16px);
        margin-bottom: 32px;
        &:last-child {
          flex: 1;
        }
      }

      &.showOther {
        position: relative;
        padding-bottom: 90px;
      }
      &.investOther {
        position: relative;
        padding-bottom: 90px;
      }
    }

    .financial-cards {
      margin-top: 34px;
    }

    .funding-source {
      padding: 52px 36px 32px;

      .subTitle {
        margin-bottom: 32px;
        color: #17161C;
        font-size: 32px;
        line-height: 32px;
        font-weight: 500;
      }
    }

    .investmentGoal {
      padding: 36px 32px 32px;
    }

    .investment-cards {
      padding-top: 26px;
    }

    .other {
      display: flex;
      flex-direction: column;
      justify-content: center;
      border-radius: 8px;
      padding: 20px 32px;
      box-sizing: border-box;
      position: relative;
      flex: 1;
      &.error {
        &:after {
          border-color: #FD2626;
        }
      }
      &:after{
        content: '';
        position: absolute;
        margin-top: -1px;
        top: -50%;
        left: -50%;
        width: 200%;
        height: 200%;
        border: 1px solid rgba(23, 22, 28, 0.25);
        transform: scale(0.5);
        border-radius: 20px;
      }
      &.focus{
        &:after{
          border-color: #17161C;
        }
        ::v-deep .van-cell{
          input {
            &::placeholder {
              font-size: 0;
            }
          }
        }
      }
      .label {
        font-size: 24px;
        line-height: 24px;
        transform: translate3d(0,0,0);
            animation: labelAni .2s .1s linear both;
        padding: 4px 0 20px;
      }
      @keyframes labelAni{
        0%{
          font-size: 28px;
        }
        100%{
          font-size: 24px;
        }
      }
      ::v-deep .van-cell {
        min-height: 0px;
        font-size: 32px;
        line-height: 32px;
        padding: 0px;
        input{
          z-index: 2;
          font-weight: 500;
          &::placeholder {
            font-size: 28px;
            color: #747377;
            font-weight: normal;
          }
          &:focus ~ .van-field__body{
            background: red;
          }
        }
      }

      &.outerSpacing {
        width: 100%;
        left: 0;
        margin-top: 25px;
      }
    }
    .errorText {
      margin-top: 12px;
      color: #fd2626;
      font-size: 24px;
    }
  }

  .financial-cards,
  .investment-cards {
    display: flex;
    flex-direction: column;
    padding: 0 32px;
  }

  .card {
    display: flex;
    flex-direction: row;
    align-items: center;
    position: relative;
    padding: 20px 32px;
    box-sizing: border-box;
    &:after{
      content: '';
      position: absolute;
      margin-top: -1px;
      top: -50%;
      left: -50%;
      width: 200%;
      height: 200%;
      border: 1px solid rgba(23, 22, 28, 0.25);
      transform: scale(0.5);
      border-radius: 20px;
    }
    .left {
      display: flex;
      flex-direction: column;
      flex: 1;
      .label {
        color: #747377;
        padding: 4px 0 20px;
        font-size: 24px;
        line-height: 24px;
      }
      .value {
        color: #17161C;
        font-weight: 500;
        font-size: 32px;
        line-height: 36px;
      }
    }
    &:not(:last-child) {
      margin-bottom: 24px;
    }
  }
  .special {
    margin-bottom: 24px;
  }
  .modify {
    margin: -12px 0px 12px 0px !important;
  }
  .button-group {
    display: flex;
    justify-content: space-between;
    margin-top: 60px;

    .van-button {
      width: 240px;
      height: 88px;
      font-size: 32px;
    }
  }

  .van-radio-group {
    display: flex;
    gap: 40px;
  }

  .residence {
    padding: 38px 36px 0px;

    .subTitle {
      margin-bottom: 32px;
      color: #17161C;
      font-size: 32px;
      line-height: 32px;
      font-weight: 500;
    }

    .residence-options {
      .option-group {
        display: flex;

        .mainRadio {
          margin-right: 60px;
        }

        .subRadio {
          width: 220px;
        }

        &:first-child {
          margin-bottom: 30px;
        }
      }

      .sub-options {
        margin-top: 30px;
        margin-left: 40px;
      }
    }
  }

  .derivatives-trading {
    display: flex;
    flex-direction: column;
  }
  .derivativeKnow {
    border: 1px dashed #D6D5D6;
    padding: 20px;
    border-radius: 8px;
    .konwtitle {
      color: #F24E1E;
      font-size: 24px;
      margin-bottom: 16px;
    }

    .check-dom {
      .dom-title {
        font-weight: 500;
        font-size: 32px;
        margin-bottom: 32px;
      }
      .itemChoices {
        margin-bottom: 32px;
        flex: 1 1 calc(50% - 32px);
        min-width: 0;
        margin-right: 0px !important;
      }
      .dom-chek {
        margin-top: 10px;
        padding-bottom: 10px;
        gap: 0;
        .itemRadio {
          margin-right: 0px !important;
          flex: 1 1 calc(50% - 32px);
        }
      }
      &:nth-of-type(3) {
        margin: 20px 0px;
      }
    }
  }

  .children-wrap {
    padding-top: 10px;
    .detail-wrap {
      padding: 0 30px;
      padding-left: 0;
      h2,
      h3 {
        padding-bottom: 20px;
      }
      p {
        padding: 10px 0;
        line-height: 45px;
      }
    }
    .no-agree {
      padding: 0 30px;
      padding-left: 0;
      margin-top: 30px;
      /deep/ .van-checkbox {
        align-items: flex-start;
        .van-checkbox__icon {
          transform: translateY(4px);
        }
        .van-checkbox__label {
          line-height: 42px;
        }
      }
    }
  }
}
.picker-popup{
  border-radius: 32px 32px 0 0;
  padding-top: 32px;
}
.date-title{
  line-height: 100px;
  text-align: center;
  font-size: 32px;
  font-weight: 500;
}
.en {
  .outerSpacing {
    margin-top: 55px !important;
  }
  .investOther {
    .outerSpacing {
      margin-top: 28px !important;
    }
  }
  .mainRadio {
    white-space: nowrap;
  }
  .option-group:first-child {
    .subRadio:last-child {
      white-space: nowrap;
      width: 280px;
      transform: translateX(-30px);
    }
  }
  .option-group:last-child {
    .subRadio:last-child {
      white-space: nowrap;
      width: 280px;
      transform: translateX(-82px);
    }
  }
  /deep/ .van-checkbox {
    align-items: flex-start;
  }
}
.black-theme {
  .suitability-survey, .survey-section {
    background: #1B1C24 !important;
    .mainTitle {
      color: white;
      border-bottom: 1px solid #323442;
    }
    .financial-cards {
      .card {
        &:after{
          border-color: rgba(255,255,255,0.25);
        }
        .label {
          color: #9D9D9F;
        }
        .value {
          color: white;
        }
      }
    }
    .funding-source {
      .subTitle {
        color: white;
      }
    }
    .residence {
      .subTitle {
        color: white;
      }
      /deep/ .van-radio__label {
        color: white;
      }
      /deep/ .van-radio__icon--checked .van-icon {
        background-color: #1989fa;
        border-color: #1989fa;
      }
    }
    .other {
      border-color: rgba(255,255,255,0.45);
      &:after{
        border-color: rgba(255,255,255,0.25);
      }
      &.focus{
        &:after{
          border-color: rgba(255,255,255,0.25);
        }
    }
      .label {
        color: #9D9D9F;
      }
    }
    .investment-cards {
      .card {
        &:after{
          border-color: rgba(255,255,255,0.25);
        }
        .label {
          color: #9D9D9F;
        }
        .value {
          color: white;
        }
      }
    }
    .children-wrap {
      color: white;
    }
    .dom-title {
      color: white;
    }
    /deep/ .van-radio__label {
      color: white;
    }
  }

}

/deep/ .van-checkbox__label {
  font-size: 28px;
  line-height: 28px;
}

/deep/ .van-checkbox__icon {
  display: flex;
  align-items: center;
}
/deep/ .van-radio__icon {
  display: flex;
  align-items: center;
}
/deep/ .van-radio__label {
  font-size: 28px;
}

// icon
.img-icon{
  width: 28px;
  height: 28px;
}
@supports (-webkit-touch-callout: none) {
  .img-icon {
    transform: translateY(-2px);
  }
}
</style>
